import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategorySection() {
  return (
    <section className="w-full border-y border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-14 md:px-8 md:py-20">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="text-xs tracking-[0.24em] text-secondary-600">CATEGORIES</p>
            <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              按领域找对比
            </h2>
          </div>
          <p className="max-w-xl text-sm leading-relaxed text-foreground-600">
            不同内容方向的形象变化逻辑并不相同：美妆看妆面结构，穿搭看版型配色，知识区看气质沉淀。
          </p>
        </div>

        <ul className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {categories.map((category) => (
            <li key={category.slug}>
              <Link
                to={`/bang?cat=${category.slug}`}
                className="group flex h-full cursor-pointer flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-secondary-400"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                  <i className={`${category.icon} text-xl`}></i>
                </span>
                <h3 className="mt-4 flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                  {category.name}
                  <span className="text-xs font-normal text-foreground-500">
                    {category.count} 位
                  </span>
                </h3>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
                  {category.desc}
                </p>
                <span className="mt-4 inline-flex items-center gap-1 text-xs font-medium text-secondary-700 transition-colors group-hover:text-primary-600">
                  进入该领域
                  <i className="ri-arrow-right-line"></i>
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}